import Styles from "../../../styles/report/mobile/bodymobileweight.module.scss";

const BodyWeightMobile = ({ report }) => {
  // const chartData = {
  //   bodyWeight: {
  //     title: "Body Weight (kg)",
  //     data: [
  //       { label: "Block 1", value: report?.[0]?.body?.weight, color:"#666666" },
  //       { label: "Block 2", value: report?.[1]?.body?.weight, color:"#ff8c42"},
  //       { label: "Block 3", value: report?.[2]?.body?.weight, color:"#ffffff"},
  //       { label: "Block 4", value: report?.[3]?.body?.weight, color:"#BB6307"},
  //     ],
  //   },
  //   muscleMass: {
  //     title: "Muscle Mass (kg)",
  //     data: [
  //       { label: "Block 1", value: report?.[0]?.body?.muscle,color:"#666666" },
  //       { label: "Block 2", value: report?.[1]?.body?.muscle,color:"#ff8c42" },
  //       { label: "Block 3", value: report?.[2]?.body?.muscle,color:"#ffffff" },
  //       { label: "Block 4", value: report?.[3]?.body?.muscle ,color:"#BB6307"},
  //     ],
  //   },
  //   bodyFat: {
  //     title: "Body Fat (%)",
  //     data: [
  //       { label: "Block 1", value: report?.[0]?.body?.fat,color:"#666666" },
  //       { label: "Block 2", value: report?.[1]?.body?.fat,color:"#ff8c42" },
  //       { label: "Block 3", value: report?.[2]?.body?.fat,color:"#ffffff" },
  //       { label: "Block 4", value: report?.[3]?.body?.fat,color:"#BB6307" },
  //     ],
  //   },
  // };


  // const maxValue = 100;

  // Responsive grid values - fewer on mobile
  
  
  
  
   const sortedReports = Array.isArray(report)
    ? [...report].sort(
        (a, b) =>
          (a?.block ?? Number.MAX_SAFE_INTEGER) -
          (b?.block ?? Number.MAX_SAFE_INTEGER)
      )
    : [];

  const reportsByBlock = new Map(
    sortedReports
      .filter((r) => Number.isFinite(r?.block))
      .map((r) => [r.block, r])
  );

  const blocks = [1, 2, 3, 4];

  const chartData = {
    bodyWeight: {
      title: "Body Weight (kg)",
      data: blocks.map((b) => ({
        label: `Block ${b}`,
        value: reportsByBlock.get(b)?.body?.weight,
        color:
          b === 1
            ? "#666666"
            : b === 2
            ? "#ff8c42"
            : b === 3
            ? "#ffffff"
            : "#BB6307",
      })),
    },
    muscleMass: {
      title: "Muscle Mass (kg)",
      data: blocks.map((b) => ({
        label: `Block ${b}`,
        value: reportsByBlock.get(b)?.body?.muscle,
        color:
          b === 1
            ? "#666666"
            : b === 2
            ? "#ff8c42"
            : b === 3
            ? "#ffffff"
            : "#BB6307",
      })),
    },
    bodyFat: {
      title: "Body Fat (%)",
      data: blocks.map((b) => ({
        label: `Block ${b}`,
        value: reportsByBlock.get(b)?.body?.fat,
        color:
          b === 1
            ? "#666666"
            : b === 2
            ? "#ff8c42"
            : b === 3
            ? "#ffffff"
            : "#BB6307",
      })),
    },
  };

  const maxValue = 100;
  
  
  
  
  
  const getGridValues = () => {
    if (typeof window !== "undefined" && window.innerWidth < 480) {
      return [0, 25, 50, 75, 100];
    }
    if (typeof window !== "undefined" && window.innerWidth < 768) {
      return [0, 20, 40, 60, 80, 100];
    }
    return [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  };

  const ChartComponent = ({ title, data }) => {
    const gridValues = getGridValues();

    return (
      <div>
        <h3 className={Styles.chartTitle}>{title}</h3>
        <div className={Styles.chartContainer}>
          <div className={Styles.chartContent}>
            <div className={Styles.yAxis}>
              {data.map((item, index) => (
                <div key={index} className={Styles.yLabel}>
                  {item.label}
                </div>
              ))}
            </div>
            <div className={Styles.chartArea}>
              <div className={Styles.gridBackground}>
                {/* Vertical grid lines */}
                {gridValues.map((value, index) => (
                  <div
                    key={index}
                    className={Styles.gridLine}
                    style={{ left: `${(value / maxValue) * 100}%` }}
                  ></div>
                ))}
              </div>
              <div className={Styles.barsContainer}>
                {data.map((item, index) => (
                  <div key={index} className={Styles.barRow}>
                    <div
                      className={Styles.bar}
                      style={{
                      width: `${(item.value / maxValue) * 100}%`,
                      background: `${item.color}`
                    }}
                    ></div>
                  </div>
                ))}
              </div>
              <div className={Styles.xAxis}>
                {gridValues.map((value, index) => (
                  <span key={index}>{value}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={Styles.bodyweightDashboard}>
      <div className={Styles.chartsGrid}>
        <ChartComponent
          title={chartData.bodyWeight.title}
          data={chartData.bodyWeight.data}
        />

        <ChartComponent
          title={chartData.muscleMass.title}
          data={chartData.muscleMass.data}
        />
        <ChartComponent
          title={chartData.bodyFat.title}
          data={chartData.bodyFat.data}
        />
     
      </div>
    </div>
  );
};

export default BodyWeightMobile;
